"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable import/no-extraneous-dependencies */
const next12_utils_request_1 = __importDefault(require("@gcloud-npm/next12.utils.request"));
const next12_utils_sonda_1 = __importDefault(require("@gcloud-npm/next12.utils.sonda"));
const PATHS = {
    GET_INFO_CONTEXT: "/mimovistar-cliente/publico/api/status/infocontexto",
};
const processName = "ADABYRON-API";
const getInfoContext = ({ context }) => {
    const sonda = new next12_utils_sonda_1.default({
        eventName: "CCLI.GETINFOCONTEXT",
        context,
        origin: processName,
    });
    const uniqueUID = `uniqueUID=CT${Date.now()}`;
    const { legadoNoVCM: connectionData, name } = context.environment;
    const { endpoint: host } = connectionData;
    const URL_API = `https://www.movistar.es${PATHS.GET_INFO_CONTEXT}?${uniqueUID}`;
    try {
        const request = new next12_utils_request_1.default({
            method: "GET",
            endpoint: URL_API,
            sonda,
            headers: {
                withCredentials: true,
                timeout: 2000,
            },
        });
        return request.makeRequest();
    }
    catch (err) {
        sonda.errorJs(err);
        return null;
    }
};
exports.default = getInfoContext;
//# sourceMappingURL=index.js.map